$(function () {
    // Thêm vào giỏ hàng
    $("#add-to-cart").on("click", function () {
        const productId = $(this).data("id");
        const optionId = $(this).data("option");
        const quantity = $(".inp-quantity").val();
        const token = $('meta[name="csrf-token"]').attr("content");
        $.ajax({
            url: routes.addToCart,
            method: "POST",
            data: {
                _token: token,
                product_id: productId,
                option_id: optionId,
                qty: quantity,
            },
            success: function (response) {
                if (response.message) {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "success",
                        title: response.message,
                        showConfirmButton: false,
                        timer: 1500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                        },
                    });
                }
            },
            error: function (xhr) {
                if (xhr.responseJSON.message) {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: xhr.responseJSON.message,
                        showConfirmButton: false,
                        timer: 1500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                        },
                    });
                }
            },
        });
    });

    // Mua ngay
    $("#buy-now").on("click", function () {
        const productId = $(this).data("id");
        const optionId = $(this).data("option");
        const quantity = $(".inp-quantity").val();
        const token = $('meta[name="csrf-token"]').attr("content");

        $.ajax({
            url: routes.addToCart,
            method: "POST",
            data: {
                _token: token,
                product_id: productId,
                option_id: optionId,
                qty: quantity,
            },
            success: function (response) {
                if (response.message) {
                    window.location.href = routes.cart; // Chuyển đến trang giỏ hàng
                }
            },
            error: function (xhr) {
                if (xhr.responseJSON.message) {
                    Swal.fire({
                        toast: true,
                        position: "top-end",
                        icon: "error",
                        title: xhr.responseJSON.message,
                        showConfirmButton: false,
                        timer: 1500,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.onmouseenter = Swal.stopTimer;
                            toast.onmouseleave = Swal.resumeTimer;
                        },
                    });
                }
            },
        });
    });
});
